interface StepProps {
	name: string;
	children: React.ReactNode;
	description?: string;
	enabled: boolean;
	nextLabel?: string;
	onBeforeNext?: () => Promise<boolean> | boolean;
	readOnly?: boolean;
}

/**
 * Descriptor component for a single step in a StepContainer.
 * StepContainer reads props from this component to build the header.
 * The children are rendered when this step is active.
 */
export const Step: React.FC<StepProps> = ({ children }) => {
	return <>{children}</>;
};

export type { StepProps };
